import React, { memo } from 'react';
import PropTypes from 'prop-types';
import BaseListItem from './base-list-item';
import './list-item.scss';

const EntityListItem = ({ dataType, category_dict, ...otherProps }) => (
  <BaseListItem
    {...otherProps}
    dataType={dataType}
    category_dict={category_dict}
  />
);

EntityListItem.propTypes = {
  category_dict: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  dataType: PropTypes.string
};

export default memo(EntityListItem);
